export const resources = {
  accountUnavailableDialog_Arm_Text: ''
};
